import { createSlice } from '@reduxjs/toolkit';
import { initStateGetEmployerStats, reducerGetEmployerStats } from '../actions/employer/getEmployerStats';
import { filterEmployer } from '../../pages/Contractor/ContractorMenu';
import { initStateGetEmployerList, reducerGetEmployerList } from '../actions/employer/getEmployerList';
import { initStateApproveEmployer, reducerApproveEmployer } from '../actions/employer/approveEmployer';
import { initStateBlockEmployer, reducerBlockEmployer } from '../actions/employer/blockEmployer';
import { initStateGetEmployerById, reducerGetEmployerById } from '../actions/employer/getEmployerById';
import { initStateCreateEmployer, reducerCreateEmployer } from '../actions/employer/createEmployer';
import { initStateBlockListEmployer, reducerBlockListEmployer } from '../actions/employer/blockListEmployer';
import { initStateApproveListEmployer, reducerApproveListEmployer } from '../actions/employer/approveListEmployer';
import { initStateDeleteEmployer, reducerDeleteEmployer } from '../actions/employer/deleteEmployer';
import { initStateDeleteListEmployer, reducerDeleteListEmployer } from '../actions/employer/deleteListEmployer';

export const initialState = {
  ...initStateGetEmployerStats,
  ...initStateGetEmployerList,
  ...initStateApproveEmployer,
  ...initStateBlockEmployer,
  ...initStateGetEmployerById,
  ...initStateCreateEmployer,
  ...initStateBlockListEmployer,
  ...initStateApproveListEmployer,
  ...initStateDeleteEmployer,
  ...initStateDeleteListEmployer,

  activeEmployerFilter: {
    label: 'Все',
    value: 'all',
    params: { is_active: true, is_verified: true, is_blocked: false },
    statValue: 'total',
    emptyText: 'Контрагентов нет',
  },
  textEmployerFilter: '',
  sortEmployerList: false,
};

export const employerSlice = createSlice({
  name: 'employer',
  initialState,
  reducers: {
    setSortEmployerList(state, action) {
      state.sortEmployerList = action.payload;
    },
    setActiveEmployerFilter(state, action) {
      state.activeEmployerFilter = action.payload;
    },
    setTextEmployerFilter(state, action) {
      state.textEmployerFilter = action.payload;
    },
    resetBlockEmployer(state, action) {
      state.blockEmployer = initStateBlockEmployer.blockEmployer;
    },
    resetBlockListEmployer(state, action) {
      state.blockListEmployer = initStateBlockListEmployer.blockListEmployer;
    },
    resetDeleteEmployer(state, action) {
      state.deleteEmployer = initStateDeleteEmployer.deleteEmployer;
    },
    resetDeleteListEmployer(state, action) {
      state.deleteListEmployer = initStateDeleteListEmployer.deleteListEmployer;
    },
    resetApproveEmployer(state, action) {
      state.approveEmployer = initStateApproveEmployer.approveEmployer;
    },
    resetCreateEmployer(state, action) {
      state.createEmployer = initStateCreateEmployer.createEmployer;
    },
    resetGetEmployerList(state, action) {
      state.getEmployerList = initStateGetEmployerList.getEmployerList;
    },
    resetGetEmployerById(state, action) {
      state.getEmployerById = initStateGetEmployerById.getEmployerById;
    },
  },
  extraReducers: {
    ...reducerGetEmployerStats,
    ...reducerGetEmployerList,
    ...reducerApproveEmployer,
    ...reducerBlockEmployer,
    ...reducerGetEmployerById,
    ...reducerCreateEmployer,
    ...reducerBlockListEmployer,
    ...reducerApproveListEmployer,
    ...reducerDeleteEmployer,
    ...reducerDeleteListEmployer,
  },
});
export const { setSortEmployerList, resetDeleteEmployer, resetDeleteListEmployer, resetGetEmployerById, resetBlockListEmployer, resetCreateEmployer, resetBlockEmployer, resetApproveEmployer, setActiveEmployerFilter, setTextEmployerFilter, resetGetEmployerList } = employerSlice.actions;
export const employerReducer = employerSlice.reducer;
